import React from 'react';
import PropTypes from 'prop-types';

import './flag.scss';

const FlagView = (props) => {
  let classString = [];

  if (props.flagColor && props.flagColor !== '') {
    classString.push(`m-tile__flag--color-${props.flagColor}`);
  } else {
    classString.push('m-tile__flag--color-black');
  }

  if (props.flagOrientation && props.flagOrientation !== '') {
    classString.push(`m-tile__flag--orientation-${props.flagOrientation}`);
  } else {
    classString.push('m-tile__flag--orientation-left');
  }

  classString = classString.join(' ');

  return (
    props.flag !== '' ? (<div className={`m-tile__flag ${classString}`}>{props.flag}</div>) : null
  );
};

FlagView.propTypes = {
  flag: PropTypes.string,
  flagColor: PropTypes.string,
  flagOrientation: PropTypes.string,
};

FlagView.defaultProps = {
  flag: '',
  flagColor: 'black',
  flagOrientation: 'left',
};

export default FlagView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/Flag/FlagView.jsx